import { Directive, Input, OnInit, Renderer2, ElementRef } from '@angular/core';
import { FormGroupDirective, AbstractControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[dynamicRequiredField]'
})
export class DynamicRequiredFieldDirective implements OnInit {
  @Input() formControlName!: string;
  private subscriptions: Subscription[] = [];

  constructor(
    private renderer: Renderer2,
    private el: ElementRef,
    private formGroupDirective: FormGroupDirective
  ) {}

  ngOnInit(): void {
    const formGroup = this.formGroupDirective.form;
    const control = formGroup.get(this.formControlName);

    if (control) {
      // Initial check
      this.updateLabel(control);

      
      this.subscriptions.push(
        control.valueChanges.subscribe(() => this.updateLabel(control)),
        control.statusChanges.subscribe(() => this.updateLabel(control))
      );
    }
  }

  private updateLabel(control: AbstractControl): void {
    const isRequired = this.hasRequiredValidator(control);
    this.toggleAsterisk(isRequired);
  }

  private hasRequiredValidator(control: AbstractControl): boolean {
    return control.validator ? !!control.validator({} as any)?.required : false;
  }

  private toggleAsterisk(isRequired: boolean): void {
    const labelElement = this.el.nativeElement.parentElement?.querySelector('label');
    
    if (labelElement) {
      let existingAsterisk = labelElement.querySelector('.required-asterisk');

      if (isRequired) {
        if (!existingAsterisk) {
          const asterisk = this.renderer.createElement('span');
          this.renderer.addClass(asterisk, 'required-asterisk');
          this.renderer.setStyle(asterisk, 'color', 'red');
          this.renderer.setStyle(asterisk, 'font-weight', 'bold');
          this.renderer.setStyle(asterisk, 'font-size', '1.2em');
          this.renderer.appendChild(asterisk, this.renderer.createText(' *'));
          this.renderer.appendChild(labelElement, asterisk);
        }
      } else if (existingAsterisk) {
        this.renderer.removeChild(labelElement, existingAsterisk);
      }
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
